// components/HeroSection.js
import React from 'react';
import '../styles/HeroSection.css';

function HeroSection() {
  const handleCTAClick = () => {
    // Scroll to about section or handle registration
    const aboutSection = document.querySelector('.about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (

    <div className="hero-image-wrapper">
<img
src="/images/1.png"
alt="Event poster wide"
className="hero-image"
/>
</div>

  );
}

export default HeroSection;
